import { useSession } from '#pplx/frontend/auth/useSession.js';
export const useIsEnterpriseUser = () => {
    const { session } = useSession();
    const orgUUID = session?.user?.org_uuid;
    return Boolean(orgUUID && orgUUID !== 'none');
};
//# sourceMappingURL=useIsEnterpriseUser.js.map